<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-劳保-修改
    -->
    <el-dialog
    title="修改劳保"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

        <el-form-item label="劳保名称" prop="name"><el-input v-model="form.name" placeholder="请输入劳保名称" class="max-w460"></el-input></el-form-item>

<el-form-item label="岗位" prop="post"><el-input v-model="form.post" placeholder="请输入岗位" class="max-w460"></el-input></el-form-item>
<el-form-item label="数量" prop="quantity"><el-input v-model="form.quantity" placeholder="请输入数量" class="max-w460" type="number"></el-input></el-form-item>
<el-form-item label="签名员工" prop="signature_employee_id">
          <el-input v-model="form.signature_employee_name" placeholder="请选择签名员工" class="max-w460" readonly></el-input>
          <el-button type="primary" size="small" @click="openEmployeeSelect" style="margin-left: 10px;">选择员工</el-button>
        </el-form-item>
        
        <!-- 员工选择弹窗 -->
        <el-dialog
          title="选择签名员工"
          :visible.sync="employeeDialogVisible"
          width="70%"
        >
          <div class="employee-select">
            <!-- 员工搜索 -->
            <el-form :inline="true" :model="employeeSearchForm" size="small" class="mb20">
              <el-form-item label="姓名：">
                <el-input v-model="employeeSearchForm.name" placeholder="请输入姓名" style="width: 150px;"></el-input>
              </el-form-item>
              <el-form-item label="手机号：">
                <el-input v-model="employeeSearchForm.phone" placeholder="请输入手机号" style="width: 150px;"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchEmployees">查询</el-button>
                <el-button @click="resetEmployeeSearch">重置</el-button>
              </el-form-item>
            </el-form>
            
            <!-- 员工列表 -->
            <el-table
              :data="employeeList"
              style="width: 100%"
              @row-click="selectEmployee"
              highlight-current-row
            >
              <el-table-column prop="ma_employee_id" label="员工ID" width="80"></el-table-column>
              <el-table-column prop="name" label="姓名" width="120"></el-table-column>
              <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
              <el-table-column prop="gender" label="性别" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.row.gender === 1 ? '男' : '女' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="political_status" label="政治面貌"></el-table-column>
              <el-table-column prop="id_card" label="身份证号"></el-table-column>
            </el-table>
            
            <!-- 分页 -->
            <div class="pagination-container" style="margin-top: 20px;">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="employeeTotal"
                :page-size.sync="employeePageSize"
                :current-page.sync="employeeCurrentPage"
                @size-change="handleEmployeeSizeChange"
                @current-change="handleEmployeeCurrentChange"
              ></el-pagination>
            </div>
          </div>
        </el-dialog>
<!-- <el-form-item label="时间" prop="time">
  <el-date-picker v-model="form.time" type="datetime" placeholder="请选择时间" class="max-w460"></el-date-picker>
</el-form-item> -->
      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
      </div>
</el-dialog>
  
</template>

<script>
import Ma_labor_protectionApi from '@/api/ma_labor_protection.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import AfuncApi from '@/api/afunc.js';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        // categorya:{
        //   name:""
        // },
        image:[],
        sort:50,
        intro:"",
        bannar:[],
        signature_employee_id: '',
        signature_employee_name: '',
        signature: ''
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入劳保名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
      /*员工选择相关数据*/
      employeeDialogVisible: false,
      employeeList: [],
      employeeTotal: 0,
      employeeCurrentPage: 1,
      employeePageSize: 10,
      employeeSearchForm: {
        name: '',
        phone: ''
      }
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","ma_labor_protection_id"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Ma_labor_protectionApi.detail({ma_labor_protection_id: self.ma_labor_protection_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;

      form.ma_labor_protection_id = self.ma_labor_protection_id;
     // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_labor_protectionApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*打开员工选择弹窗*/
    openEmployeeSelect() {
      this.employeeCurrentPage = 1;
      this.employeeSearchForm = {
        name: '',
        phone: ''
      };
      this.loadEmployees();
      this.employeeDialogVisible = true;
    },
    
    /*加载员工数据*/
    async loadEmployees() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_employee',
          action: 'index',
          page: this.employeeCurrentPage,
          list_rows: this.employeePageSize,
          ...this.employeeSearchForm
        });
        
        if (response.code === 1) {
          this.employeeList = response.data.list.data || [];
          this.employeeTotal = response.data.list.total || 0;
        }
      } catch (error) {
        console.error('加载员工列表失败:', error);
      }
    },
    
    /*搜索员工*/
    searchEmployees() {
      this.employeeCurrentPage = 1;
      this.loadEmployees();
    },
    
    /*重置员工搜索*/
    resetEmployeeSearch() {
      this.employeeSearchForm = {
        name: '',
        phone: ''
      };
      this.employeeCurrentPage = 1;
      this.loadEmployees();
    },
    
    /*选择员工*/
    selectEmployee(row) {
      this.form.signature_employee_id = row.ma_employee_id;
      this.form.signature_employee_name = row.name;
      this.form.signature = row.signature || '';
      this.employeeDialogVisible = false;
    },
    
    /*处理员工分页大小变化*/
    handleEmployeeSizeChange(size) {
      this.employeePageSize = size;
      this.loadEmployees();
    },
    
    /*处理员工分页当前页变化*/
    handleEmployeeCurrentChange(current) {
      this.employeeCurrentPage = current;
      this.loadEmployees();
    },
    
    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_labor_protection/index/part/edit.vue